/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

/**
 * This model
 * @type {[type]}
 */
module.exports = Model({
	name: "hangupreply",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_who: null,

	cancel: cancel
});

function init() {
	this._localization = {};

	this.push({
		view: false,
	});
}

function listeners() {
	return {
		"calling:updated": handel_calling_updated,
	};
}

function triggers() {
	return {
		"view": view,
		"send": send_autoreply,
		"cancel": cancel
	};
}

function view() {
	this.push({
		view: true,
	});
	this.emit("usermetrics:trigger:track", "open confirm hangup and send message popup", {
		who: this._who,
	})
}

function send_autoreply(data) {
	var autoreply = data.autoreply;
	var to = this._who;
	var popup = true;
	if (!autoreply || !to) {
		this.cancel();
	}
	else {
		this.api.messages
			.send
			.message(to, autoreply, popup)
			.catch(console.error.bind(console));
	}
	this.emit("usermetrics:trigger:track", "hangup and send message in old calling", {
		to: this._who,
	})

	this.emit("calling:trigger:deny", {
		reason: "deny",
		who: to,
	});
}

function cancel() {
	if(!!this.data.view) {
		this.push({
			view: false,
		});
		this.emit("usermetrics:trigger:track", "cancel confirm hangup and send message popup", {
			who: this._who,
		})
	}
}

function handel_calling_updated(data) {
	if(data.state === "idle") {
		this.cancel();
	} else {
		var who = data.who;
		if(!who) return;
		this._who = who._id;
	}
}